// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Heading from "../../components/Highlightedheading/Heading";
import Pageheading from "../../components/PageHeading/Pageheading";
import { RiHome2Line } from "react-icons/ri";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import { mediaAssets } from "../../assets/media";
import "./media.scss";
import { useWindowSize } from "react-use";
import contactimg from "../../assets/media/Banner.png";
import mobileimg from "../../assets/media/Banner_Mobile.png";
import BannerHeading from "../../components/BannerHeading/Heading";

const Media = () => {
  const { width } = useWindowSize();
  const latestData = [
    {
      img: mediaAssets.Latest_1,
      desc: "‘Hanuman Da Damdaar’ has Salman Khan, animation, songs and a big-budget feel",
      date: "20th May, 2017",
      link: "https://scroll.in/reel/838153/hanuman-da-damdaar-has-salman-khan-animation-songs-and-a-big-budget-feel",
    },
    {
      img: mediaAssets.Latest_2,
      desc: "Salman Khan's Hanuman Da Damdaar to be biggest pan-Indian release",
      date: "8th May, 2017",
      link: "https://www.deccanchronicle.com/entertainment/bollywood/080517/salman-khans-hanuman-da-damdaar-to-be-biggest-pan-indian-release.html",
    },
    {
      img: mediaAssets.Latest_3,
      desc: "‘Guilty’: Real story of modern times",
      date: "9th March, 2020",
      link: "https://www.nationalheraldindia.com/entertainment/guilty-real-story-of-modern-times",
    },
    {
      img: mediaAssets.Latest_4,
      desc: "Guilty | Interview | Kiara Advani | Ruchi Narain | Netflix | Anupama Chopra | Film Companion",
      date: "7th March, 2020",
      link: "https://www.youtube.com/watch?v=uyUmhicUjRk",
    },
    {
      img: mediaAssets.Latest_5,
      desc: "Netflix's Guilty interview: Kiara Advani, Akansha Ranjan Kapoor predict film will inspire debates",
      date: "9th March, 2020",
      link: "https://www.youtube.com/watch?v=fKfk_X0ThWM",
    },
    {
      img: mediaAssets.Latest_6,
      desc: "Never Have I Ever ft. Kiara Advani, Akansha Ranjan, Gurfateh, Taher Shabbir | Guilty | Netflix India",
      date: "7th March, 2020",
      link: "https://www.youtube.com/watch?v=K2TTV-BLnrk",
    },
    {
      img: mediaAssets.Latest_7,
      desc: "Karmma Calling Review: Promises Even Darker And More Scandalising Conspiracies To Come",
      date: "25th Jan, 2024",
      link: "https://www.freepressjournal.in/entertainment/karmma-calling-review-promises-even-darker-and-more-scandalising-conspiracies-to-come",
    },
    {
      img: mediaAssets.Latest_8,
      desc: "Homepage  Just Binge  Binge NewsKarmma Calling Producer Ashutosh Shah On Working With Raveena Tandon; Says, '10 Years Ago Our First Choice Was Raveena Ma’am'",
      date: "26th Jan, 2024",
      link: "https://www.spotboye.com/just-binge/binge-news/karmma-calling-producer-ashutosh-shah-on-working-with-raveena-tandon-says-10-years-ago-our-first-choice-was-raveena-ma-am/65b34989dea8131a4f7a3324",
    },
    {
      img: mediaAssets.Latest_9,
      desc: "'Karmma Calling' Review: Raveena Tandon's show is revenge drama done right",
      date: "26th Jan, 2024",
      link: "https://www.indiatoday.in/entertainment/television/story/karmma-calling-review-raveena-tandons-show-is-revenge-drama-done-right-2493536-2024-01-26",
    },
    {
      img: mediaAssets.Latest_10,
      desc: "Hotstar | Karmma Calling Producers Taher Shabbir & Ashutosh Shah On Working With Raveena Tandon",
      date: "18th Jan, 2024",
      link: "https://www.youtube.com/watch?v=JMQNzdIyAK0",
    },
    {
      img: mediaAssets.Latest_11,
      desc: "Exclusive Interview : Ruchi Narain || Karmma Calling",
      date: "13th Jan, 2024",
      link: "https://www.youtube.com/watch?v=rwoMawuRFVs",
    },
    {
      img: mediaAssets.Latest_12,
      desc: "Exclusive Interview :Taher Shabbir || Ashutosh Shah || Karmma Callin",
      date: "23rd Jan, 2024",
      link: "https://www.youtube.com/live/-afJJhrZ-Do",
    },
    {
      img: mediaAssets.Latest_13,
      desc: "Karmma Calling producers: ‘We had Raveena Tandon in mind from the inception stage’",
      date: "29th Jan, 2024",
      link: "https://www.telegraphindia.com/entertainment/karmma-calling-producers-we-had-raveena-tandon-in-mind-from-the-inception-stage/cid/1996957#goog_rewarded",
    },
    {
      img: mediaAssets.Latest_14,
      desc: "Karmma Calling producer Ashutosh Shah reveals how it took them 10 years to get Raveena Tandon on board",
      date: "25th Jan, 2024",
      link: "https://www.dnaindia.com/entertainment/report-karmma-calling-producer-ashutosh-shah-reveals-how-it-took-them-10-years-to-get-raveena-tandon-on-board-3075629",
    },
    {
      img: mediaAssets.Latest_15,
      desc: "Hanuman Da Damdaar Promises A Cool Treat This Summer",
      date: "25th April, 2020",
    },
    {
      img: mediaAssets.Latest_16,
      desc: "Hundred Review: Lara Dutta and Rinku Rajguru Bring Their Ace Game in This Hotstar Specials Series",
      date: "25th April, 2020",
      link: "https://www.latestly.com/entertainment/tv/hundred-review-lara-dutta-and-rinku-rajguru-bring-their-ace-game-in-this-hotstar-series-1708330.html#google_vignette",
    },
    {
      img: mediaAssets.Latest_17,
      desc: "Hundred review: Lara Dutta, Rinku Rajguru hit it out of the park",
      date: "29th April, 2020",
      link: "https://indianexpress.com/article/entertainment/web-series/hundred-review-disney-plus-hotstar-lara-dutta-rinku-rajguru-6383450/",
    },
    {
      img: mediaAssets.Latest_18,
      desc: "Hundred Review: Lara Dutta and Rinku Rajguru make a Zingaat entry into digital space",
      date: "25th April, 2020",
      link: "https://www.indiatoday.in/entertainment/ott/story/hundred-review-lara-dutta-and-rinku-rajguru-make-a-zingaat-entry-into-digital-space-1670884-2020-04-25",
    },
    {
      img: mediaAssets.Latest_19,
      desc: "‘Hundred’ review: Lara Dutta and Rinku Rajguru steer a fun run to the crease",
      date: "25th April, 2020",
      link: "https://scroll.in/reel/960181/hundred-review-lara-dutta-and-rinku-rajguru-steer-a-fun-run-to-the-crease  ",
    },
    {
      img: mediaAssets.Latest_20,
      desc: "'Hundred' review: Rinku Rajguru and Lara Dutta's on-screen chemistry is worth applauding",
      date: "28th April, 2020",
      link: "https://www.republicworld.com/entertainment/hundred-series-review-featuring-rinku-rajguru-and-lara-dutta",
    },
    {
      img: mediaAssets.Latest_21,
      desc: "Hundred On Disney+ Hotstar: Twitter Is In Love With Lara Dutta And Rinku Rajguru’s Heartwarming Performances, Check Reviews",
      date: "26th April, 2020",
      link: "https://www.spotboye.com/just-binge/binge-reviews/hundred-on-disney-plus-hotstar-twitter-is-in-love-with-lara-dutta-and-rinku-rajguru-s-heartwarming-performances-check-reviews/5ea5337474f5ce660a225773",
    },
    {
      img: mediaAssets.Latest_22,
      desc: "‘Hundred’ Review: Lara Dutta aka ACP Saumya's and Rinku Rajguru aka Nethra's debut show on Disney+Hotstar is full of thrill, one adventure at a time",
      date: "25th April, 2020",
      link: "https://www.peepingmoon.com/webcast-reviews/news/43992/Hundred-Review-Lara-Dutta-aka-ACP-Saumyas-and-Rinku-Rajguru-aka-Nethras-debut-show-on-DisneyHotstar-is-full-of-thrill-one-adventure-at-a-time.html",
    },
    {
      img: mediaAssets.Latest_23,
      desc: "Hundred Review: Perfect Comeback By Lara Dutta But It’s Rinku Rajguru’s Performance You Can’t Afford To Miss",
      date: "26th April, 2020",
      link: "https://www.koimoi.com/reviews/web-reviews/hundred-review-perfect-comeback-by-lara-dutta-but-its-rinku-rajgurus-performance-you-cant-afford-to-miss/",
    },
    {
      img: mediaAssets.Latest_24,
      desc: "This Article is From Apr 27, 2020Hundred Web Series Review: रिंकू राजगुरु की धांसू एक्टिंग तो लारा दत्ता का शानदार अंदाज, फुलटू धमाल है 'हंड्रेड'",
      date: "19th May, 2020",
      link: "https://ndtv.in/television/hundred-web-series-review-hot-star-lara-dutta-rinku-rajguru-2218974",
    },
    {
      img: mediaAssets.Latest_25,
      desc: "Hundred Web Series Review: लपकने के लिए बिल्कुल परफेक्ट है लारा दत्ता और रिंकू का ये लेटेस्ट लप्पा",
      date: "26th April, 2020",
      link: "https://www.amarujala.com/photo-gallery/entertainment/movie-review/web-series-hundred-hotstar-review-by-pankaj-shukla-starring-lara-dutta-rinku-rajguru",
    },
    {
      img: mediaAssets.Latest_26,
      desc: "Hotstar Hundred Series Review, Cast, Trailer, Plot, Story",
      date: "16th May, 2020",
      link: "https://www.webseriesreviews.com/hotstar-hundred-review/#google_vignette",
    },
  ];

  const [image1, setImage1] = useState("");
  const [image2, setImage2] = useState("");

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    setImage1(isMobile ? "/media/mobilemedia-2.png" : "/media/media-2.png");
    setImage2(isMobile ? "/media/mobilemedia-3.png" : "/media/media-3.png");
  }, []);

  useEffect(() => {
    const cards = document.querySelectorAll(".latest_card");
    const bg = document.querySelector(".bg_card");

    function handleMouseOver(e) {
      const rect = e.currentTarget.getBoundingClientRect();

      const x = rect.left;
      const y = rect.top;
      const width = rect.width;
      const height = rect.height;

      // bg.style.left = "0px";
      // bg.style.top = "0px";
      // bg.style.opacity = 1;
      bg.classList.add("active");
      bg.style.width = width + "px";
      bg.style.height = height + "px";
      bg.style.transform = `translateX(${x}px) translateY(${y}px)`;
    }

    function handleMouseLeave(e) {
      bg.classList.remove("active");
    }

    cards.forEach((card) => {
      card.addEventListener("mouseover", handleMouseOver);
      card.addEventListener("mouseleave", handleMouseLeave);
    });

    return () => {
      cards.forEach((card) => {
        card.removeEventListener("mouseover", handleMouseOver);
        card.removeEventListener("mouseleave", handleMouseLeave);
      });
    };
  }, []);

  useEffect(() => {
    const preloadImages = [contactimg, mobileimg];
    preloadImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className="w-full h-full  text-white relative">
      <div className="relative w-full  h-[90vh] md:h-[40vw] 3xl:h-[60vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-transparent z-10">
          <div className="md:pl-[5.63vw] pl-4 flex items-center md:pt-[10.09vw] pt-[25vw]">
            <Pageheading pageHeading={"Media"} icon={<RiHome2Line />} />
          </div>
        </div>
        <div
          className="absolute inset-0 bg-contain md:bg-cover bg-no-repeat bg-bottom flex justify-center items-center"
          style={{
            backgroundImage: `url(${width < 768 ? mobileimg : contactimg})`,
          }}
        >
          <div className="absolute top-[25vh] md:top-[20vw] md:left-[17.47vw] flex justify-start items-center z-10">
            <BannerHeading headingText={"Media"} />
          </div>
        </div>
        <div className="absolute h-[250px] md:h-[300px] tab:h-[327px] w-full top-0 bg-gradient-to-b from-[#121614]"></div>
      </div>

      <section className="w-full px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px]">
        {/* <h2 className="w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px]  3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
          LATEST
        </h2> */}

        <h2
          data-aos="fade-up"
          className="text-left w-full text-[11vw] md:text-[5.5vw] leading-[11vw] md:leading-[5.5vw] font-bebas_neue text-transparent bg-clip-text bg-text-gradient"
        >
          LATEST
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-y-[40px] lg:gap-4 mt-8 font-montserrat relative mb-[100px]">
          <div className="bg_card w-full h-full fixed  hidden md:block md:opacity-0 transition-all duration-300 md:-left-[30px] md:top-[30px] border-[#707070] bg-glass/30 backdrop-blur-xl"></div>
          {latestData?.map(({ img, desc, date, link }, i) => (
            <>
              <Link
                key={`media-${i}`}
                target="_blank"
                to={link}
                onClick={link ? undefined : (e) => e.preventDefault()}
                data-aos="fade-up"
                className="latest_card  mb-[120px] md:mb-0 p-6 sm:p-8 xl:p-12 xl:pb-0 pb-0 sm:pb-0 relative flex flex-col border-[#707070] md:border-0 border md:bg-transparent md:backdrop-blur-0 bg-glass/30 backdrop-blur-xl"
              >
                <div>
                  <p className="font-medium text-[28px] leading-[28px] md:text-[40px] md:leading-[40px] 3xl-plus:text-[48px] 3xl-plus:leading-[48px]">
                    {date?.split(" ")[0]}
                  </p>
                  <p className="opacity-50 text-[14px] md:text-[20px] 3xl-plus:text-[28px] 3xl-plus:leading-[38px] mt-3">{`${
                    date?.split(" ")[1]
                  } ${date?.split(" ")[2]}`}</p>
                  <div className="h-[1px] bg-white opacity-50 w-[100px] my-6"></div>
                  <p className="text-[20px] leading-[28px] 3xl-plus:text-[28px] 3xl-plus:leading-[38px] opacity-70">
                    {desc}
                  </p>
                </div>
                <div className="flex-grow flex items-end">
                  <img
                    src={img}
                    alt="Latest Img"
                    className="aspect-video translate-y-[25%] w-full"
                  />
                </div>
              </Link>

              {width >= 1280 && (i + 1) % 3 === 0 && (
                <div className="h-[1.5px] w-4/5 bg-glass/30 backdrop-blur-3xl mx-auto col-span-full mt-[100px] mb-[50px] 3xl-plus:mt-[200px] 3xl-plus:mb-[100px]"></div>
              )}
              {width < 1280 && width >= 768 && (i + 1) % 2 === 0 && (
                <div className="h-[1.5px] w-4/5 bg-glass/30 backdrop-blur-3xl mx-auto col-span-full mt-[100px] mb-[50px]"></div>
              )}
            </>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Media;
